import axios from 'axios';
import { PRICE_VERSION_VARIATION_ENDPOINT } from '../../../common/endpoints';

export async function updateVersionPrice(row, optionSelectedPrice, modelVersionPrice) {
  const datamasterId = row.datamasterId
  const body = {
    price: Number(row.selectedNewPrice.replaceAll('.','')),
    modelId: row.modelId,
    year: row.year,
    modelVersionPrice
  }
  if(optionSelectedPrice.option == 'oneVersion'){
    body.oneVersion = true
  }
  try{
      return await axios.put(`${PRICE_VERSION_VARIATION_ENDPOINT}/priceVariation/${datamasterId}`, body)
  }catch(error){
      throw error.response.data
  }
}